import styled from 'styled-components'

export const DifferentiatedServiceHeroImageMarginBottom = styled.div`
  position: relative;
  bottom: -60px;
`
